import React from 'react'

import { AlignItems, Box, Display } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import { RecipeTagGroup } from '@library/api-menu-experience/src/interfaces/recipe'

import { RecipeTags } from './RecipeTags'

import css from './RecipeAttributes.css'

type RecipeAttributesPillsProps = {
  tags?: RecipeTagGroup['tags']
  loading: boolean
}

const LoadingSkeleton = ({ style }: { style?: React.CSSProperties }) => (
  <span className={css.loadingSkeleton} style={style} data-testid="LoadingSkeleton" />
)

export const RecipeAttributesPills = ({ tags, loading }: RecipeAttributesPillsProps) => {
  if (loading) {
    return (
      <div className={classnames(css.attributes)}>
        {[...Array(4)].map((_, index) => (
          // Using the index is safe here because the list of skeletons is static and will not reorder.
          // eslint-disable-next-line react/no-array-index-key
          <LoadingSkeleton key={index} style={{ height: '10px', marginBottom: '10px' }} />
        ))}
      </div>
    )
  }

  if (!tags || tags.length === 0) {
    return null
  }

  return (
    <Box
      alignItems={AlignItems.FlexStart}
      wrap
      data-testid="RecipeAttributesPills"
      display={Display.Flex}
    >
      <RecipeTags tags={tags} />
    </Box>
  )
}
